export const contextValues = {
    FEATURE_FLAGS: 'featureFlags',
    CHIME_ROOM_ID: 'chimeRoomId',
    CHIME_WEB_RTC_STATS: 'chimeWebRtcStats',
    CHIME_LOCAL_NETWORK_QUALITY: 'chimeLocalNetworkQuality',
    CHIME_REMOTE_NETWORK_QUALITY: 'chimeRemoteNetworkQuality',
    DEVICE_INFO: 'deviceInfo',
    GIT_REF: 'gitRef',
    PERMISSIONS_STATE: 'permissionState',
    ROLE: 'role',
    ROOM_ID: 'roomId',
    ROOM_PARTICIPANTS: 'roomParticipants',
    ROOM_PERFORMANCE: 'roomPerformance',
    SESSION_STATUS_CONFIG: 'sessionStatusConfig',
    TRACK_PROVIDER: 'trackProvider',
    AUDIO_TRACK_SETTINGS: 'audioTrackSettings',
    AVAILABLE_MEDIA_DEVICES: 'availableMediaDevices',
    USER_AGENT: 'userAgent',
    USER: 'user',
    USER_AVAILABILITY: 'userAvailability',
    IDENTIFIED_USER: 'identifiedUser',
    WEBRTC: 'webrtc',
};
//# sourceMappingURL=contextValues.js.map